import React, { useEffect, useState } from "react";
import { DataGridPro, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { Alert, Autocomplete, Box, Button, FormControl, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { InsuranceCompanyModel } from "../../models/insuranceCompanyModel";
import { Add, Clear, Search } from "@mui/icons-material";
import { formatUtcToLocal } from "../../helper/utils";
import useAuth from "../../context/AuthProvider";
import { AddEditCarriermanagement } from "../AddEdit/AddEditCarrierManagement";
import { stateOptions } from "../AddEdit/AddEditPartners";
import { RiExpandUpDownLine } from "react-icons/ri";
import Swal from "sweetalert2";
import { AddEditCarrierManageLineOfBussinessCheckBox } from "../AddEdit/AddEditCarrierManageLineOfBussinessCheckBox";
import { apiClient } from "../../helper/api";
import {KeyboardArrowUp, KeyboardArrowDown} from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RestoreFromTrashOutlinedIcon from '@mui/icons-material/RestoreFromTrashOutlined';


export type CarrierSearchFilters = {
    carrier?: string;
    naic?: string;
};

type CarrierLookupOption = {
    name: string;
    naicNumber?: string;
};

interface Iprops {
    InsuranceComapnyCL: InsuranceCompanyModel[],
    fetchData: (filters?: CarrierSearchFilters) => void,
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

const autocompleteFieldSx = {
    marginTop: "-4px !important",
    "& .MuiAutocomplete-input": { padding: "0px 4px 0px 5px !important" },
};

const autocompleteInputSx = {
    ".MuiFormLabel-root.Mui-focused": {
        color: "#000",
    },
    "& .MuiInputBase-root": { marginTop: "5px !important" },
    "& .MuiOutlinedInput-root": { padding: "4.5px 9px" },
    "& .MuiFormLabel-root": { transform: "translate(14px, 13px) scale(1)" },
    "& .MuiInputLabel-shrink": { transform: "translate(14px, -2px) scale(0.75)" },
};

const filterFieldSx = {
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
    "& .MuiInputBase-root": { marginTop: "1px !important" },
    "& .MuiInputBase-input": { padding: "4.5px 14px !important" },
};

export interface lineOfBusinessModel {
    id: number, businessCode: string, stateId: number
}





export const CarrierManagementList: React.FC<Iprops> = ({ InsuranceComapnyCL, fetchData, sortModel, setSortModel }) => {
    const initialICData: InsuranceCompanyModel = {
        insuranceCompanyId: 0, naicNumber: "", name: "", stateId: 0, createdBy: 0, modifiedBy: 0, dateCreated: new Date(), dateModified: new Date(), isDeleted: false,
        stateName: "", isActive: true
    };

    const { user } = useAuth();
    const token = user?.token;
    const [selectedStates, setselectedStates] = useState<stateOptions[]>([]);
    const [States, setStates] = useState<stateOptions[]>([]);
    const [selectedLineOfBusiness, setselectedLineOfBusiness] = useState<lineOfBusinessModel[]>([]);
    const [LineOfBusiness, setLineOfBusiness] = useState<lineOfBusinessModel[]>([]);
    const [carrier, setCarrier] = useState("");
    const [naic, setNaic] = useState("");
    const [carrierOptions, setCarrierOptions] = useState<CarrierLookupOption[]>([]);
    const [carrierLookupLoading, setCarrierLookupLoading] = useState(false);

    const [Open, setOpen] = React.useState(false);
    const [Open1, setOpen1] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialICData);
    const [currentState, setCurrentState] = React.useState(0);
    const [naicDatasetVersion, setNaicDatasetVersion] = React.useState<{
        releaseId?: string;
        loadDate?: string;
        appliedDate?: string;
        isStale?: boolean;
    } | null>(null);
    const [pageSize, setPageSize] = React.useState(50);
    const [page, setPage] = React.useState(0);

    const currentFilters = (): CarrierSearchFilters => ({
        carrier: carrier.trim(),
        naic: naic.trim(),
    });

    const RunSearch = () => {
        setPage(0);
        fetchData(currentFilters());
    };

    const ClearSearch = () => {
        setCarrier("");
        setNaic("");
        setCarrierOptions([]);
        setPage(0);
        fetchData({});
    };

    useEffect(() => {
        if (!token) return;
        const needle = carrier.trim();
        if (needle.length < 2) {
            setCarrierOptions([]);
            setCarrierLookupLoading(false);
            return;
        }

        let cancelled = false;
        const timer = window.setTimeout(() => {
            setCarrierLookupLoading(true);
            apiClient(
                `/InsuranceCompany/lookup?name=${encodeURIComponent(needle)}&limit=25&includeInactive=true`,
                {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    }),
                }
            )
                .then((res) => {
                    if (cancelled) return;
                    if (!res || res.ok === false || res.status === false) {
                        setCarrierOptions([]);
                        return;
                    }
                    const exact = Array.isArray(res.data?.exact) ? res.data.exact : [];
                    const candidates = Array.isArray(res.data?.candidates) ? res.data.candidates : [];
                    const seen = new Set<string>();
                    const options: CarrierLookupOption[] = [];
                    for (const row of [...exact, ...candidates]) {
                        const name = String(row?.name ?? "").trim();
                        if (!name) continue;
                        const key = name.toLowerCase();
                        if (seen.has(key)) continue;
                        seen.add(key);
                        options.push({
                            name,
                            naicNumber: row?.naicNumber ? String(row.naicNumber) : undefined,
                        });
                    }
                    setCarrierOptions(options);
                })
                .finally(() => {
                    if (!cancelled) setCarrierLookupLoading(false);
                });
        }, 300);

        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [carrier, token]);

    useEffect(() => {
        if (!token) return;
        apiClient("/InsuranceCompany/getNaicDatasetVersion", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((res) => {
                if (!res) return;
                setNaicDatasetVersion(res.data || null);
            })
            .catch(() => {
                setNaicDatasetVersion(null);
            });
    }, [token]);

    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked) {

            var id = Number(event.target.name);
            setCurrentState(id);
            getLineOfBusinessByStateId(id);

            console.log(event.target.name);
            let crrOption: stateOptions = {
                stateId: Number(event.target.name),
                stateName: '',
            }
            setselectedStates((current) => [...(current ?? []), crrOption])
        }

        else {
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to remove all line of business related to this state",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, remove them!'
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        var id = Number(event.target.name);
                        const currentLobs = selectedLineOfBusiness ?? [];
                        for (var i = 0; i < currentLobs.length; i++) {
                            if (currentLobs[i].stateId == id) {
                                currentLobs[i].businessCode = "";
                                currentLobs[i].stateId = 0;
                                currentLobs[i].id = 0;
                            }
                        }
                        setselectedStates((current) =>
                            (current ?? []).filter((obj) =>
                                obj.stateId != Number(event.target.name)
                            )
                        )
                    }
                })
        }
    };

    const handleStateEdit = (eventId: number) => {
        setCurrentState(eventId);
        getLineOfBusinessByStateId(eventId)

    }


    function getLineOfBusinessByStateId(id: number) {
        //setloading(true)
        apiClient("/LineOfBusiness/getLineOBusinessByStateId?stateId=" + `${id}`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
                method: "Get",
            }
        )
            .then((res) => {
                if (!res || res.ok === false) return;
                const rows = Array.isArray(res.data) ? res.data : [];
                if (rows.length > 0) {
                    setOpen1(true);
                    setLineOfBusiness(rows);
                } else {
                    alert("There is no line of business for this state");
                }

            })

    }

    function selectAll() {
        setselectedStates(Array.isArray(States) ? States : []);
    }

    const handleLineOfBusinessCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            console.log(event.target.name);
            var curntState = currentState;
            let crrOption: lineOfBusinessModel = {
                id: Number(event.target.name),
                businessCode: '',
                stateId: curntState
            }

            setselectedLineOfBusiness((current) => [...(current ?? []), crrOption]);

        } else {

            setselectedLineOfBusiness((current) =>
                (current ?? []).filter((obj) =>
                    obj.id != Number(event.target.name)
                )
            )
        }

    };
    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/InsuranceCompany/DeleteInsuranceCompany?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res || res.ok === false || res.status === false) {
                                Swal.fire(
                                    'Delete failed',
                                    res?.message || 'Unable to delete carrier.',
                                    'error'
                                );
                                return;
                            }
                            Swal.fire(
                                'Deleted!',
                                'Carrier has been deleted.',
                                'success'
                            );
                            fetchData(currentFilters());
                            setOpen(false);
                        }).catch((error) => {
                            console.log(error)
                        });
                }
            })
    };

    const columns: GridColDef[] = [
        { field: 'naicNumber', headerName: 'NAIC #', type: 'string', flex: 0.5, headerAlign: 'left',hideSortIcons: true, minWidth: 100,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'naicNumber'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left' },
        { field: 'name', headerName: 'Carrier', flex: 1.5, headerAlign: 'left',hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'name'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, align: 'left' },

        {
            field: 'startDate', headerName: 'Start Date', type: "date", flex: 0.5,hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'startDate'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', align: 'left', renderCell: (params) => (
                <div> {params.row.startDate ? formatUtcToLocal(params.row.startDate, "MM-DD-YYYY") : ""}</div>)

        },


        { field: 'dateModified', headerName: 'Last Modified', type: "date", flex: 0.5,hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dateModified'
                  );
              
                  const isSortedAsc = sortItem?.sort === 'asc';
                  const isSortedDesc = sortItem?.sort === 'desc'
                  return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )}, headerAlign: 'left', align: 'left', renderCell: (params) => (<div> {params.row.dateModified ? formatUtcToLocal(params.row.dateModified, "MM-DD-YYYY") : ""}</div>) },
        {
            field: 'id',
            sortable: false,
            disableColumnMenu: true,

            flex: 0.5, headerName: "Action", headerAlign: 'center', align: 'center',hideSortIcons: true, minWidth: 130,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) => (<div>
                <IconButton
                    color="primary"
                    onClick={() => { handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                    <EditOutlinedIcon fontSize="small" color="primary" />
                    </Tooltip>
                </IconButton >
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.insuranceCompanyId) }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        {params.row.isDeleted ? <RestoreFromTrashOutlinedIcon /> :
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                        }
                    </IconButton >
                    : ""}
            </div>)
        }


    ];

    const handleClickOpen = () => {
        setselectedStates([]);
        setselectedLineOfBusiness([]);
        fetchStates(0);
        fetchLineOfBusiness(0);
        setFormData(initialICData);
        setOpen(true);
    };
    const handleClose = () => {
        setselectedLineOfBusiness([]);
        setOpen(false);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleSubmit = () => {
        fetchData(currentFilters());
        setOpen(false);
    };
    const handleSubmitLineofBusinessByState = () => {
        setOpen1(false);
    };

    const fetchStates = (insuranceCompanyId: number) => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson || responseJson.ok === false) return;
                setStates(Array.isArray(responseJson.data) ? responseJson.data : []);
            }).then(() => {
                // New carrier (id 0): no mapped states yet — do not call missing/legacy endpoint
                // (404 was setting selectedStates to undefined and crashing on state checkbox click).
                if (!insuranceCompanyId || insuranceCompanyId <= 0) {
                    setselectedStates([]);
                    return;
                }
                apiClient(`/InsuranceCompany/getInsuranceCompanyStates?insuranceCompanyId=${insuranceCompanyId}`,
                    {
                        method: "GET",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        })
                    })
                    .then((responseJson) => {
                        if (!responseJson || responseJson.ok === false || responseJson.status === false) {
                            setselectedStates([]);
                            return;
                        }
                        setselectedStates(Array.isArray(responseJson.data) ? responseJson.data : []);
                    })
            })
    }


    const fetchStateData = () => {

        apiClient('/States/getStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson || responseJson.ok === false) return;
                setStates(Array.isArray(responseJson.data) ? responseJson.data : []);
            })


    }


    useEffect(() => {

        fetchStateData();
    }, [])





    const fetchLineOfBusiness = (insuranceCompanyId: number) => {
        if (insuranceCompanyId <= 0) {
            setselectedLineOfBusiness([]);
            return;
        }
        apiClient(`/InsuranceCompany/getInsuranceCompanyLineOfBusiness?insuranceCompanyId=${insuranceCompanyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson || responseJson.ok === false || responseJson.status === false) {
                    setselectedLineOfBusiness([]);
                    return;
                }
                setselectedLineOfBusiness(Array.isArray(responseJson.data) ? responseJson.data : []);
            })
    }

    const handleEdit = (ICClData: InsuranceCompanyModel) => {



        setselectedStates([]);
        setselectedLineOfBusiness([]);

        ICClData.startDate = ICClData.startDate ? ICClData.startDate.toString().split('T')[0] : "";
        console.log(ICClData);

        setFormData(ICClData);
        fetchStates(ICClData.insuranceCompanyId);
        fetchLineOfBusiness(ICClData.insuranceCompanyId);
        setOpen(true);
    };

    function EditToolbar() {
        return (
            <Box sx={{
                borderBottom: 1,
                borderColor: 'divider',
                p: 1,
            }}>
                <GridToolbarFilterButton />
            </Box>
        );
    }

    return (
        <React.Fragment>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1.5,
                        px: { xs: 4, lg: 2 },
                        py: 1.5,
                        borderBottom: '1px solid #e2e8f0',
                        backgroundColor: '#fafbfc',
                        minHeight: 56,
                        mb: 0,
                        marginLeft: { xs: '-24px', lg: '0px' },
                        marginRight: { xs: '-24px', lg: '0px' },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
                        <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                            Carrier Management
                        </h4>
                        {naicDatasetVersion?.releaseId ? (
                            <Typography variant="body2" sx={{ color: '#64748b' }}>
                                NAIC release: {naicDatasetVersion.releaseId}
                                {naicDatasetVersion.loadDate || naicDatasetVersion.appliedDate
                                    ? ` · loaded ${formatUtcToLocal(
                                          naicDatasetVersion.appliedDate || naicDatasetVersion.loadDate || "",
                                          "MM-DD-YYYY"
                                      )}`
                                    : null}
                            </Typography>
                        ) : (
                            <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                                NAIC listing not loaded yet
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                            variant="contained"
                            size="medium"
                            onClick={handleClickOpen}
                            startIcon={<Add />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                            }}
                        >
                            Add New
                        </Button>
                    </Box>
                </Box>
                <Box
                    sx={{
                        py: 2,
                        px: { xs: 2, lg: 2 },
                        backgroundColor: '#ffffff',
                        borderBottom: '1px solid #e2e8f0',
                        mb: 2,
                        marginLeft: { xs: '-24px', lg: '0px' },
                        marginRight: { xs: '-24px', lg: '0px' },
                        width: { xs: 'calc(100% + 48px)', lg: '100%' },
                    }}
                >
                    <Grid container spacing={2} className="filter-grid" display="flex" alignItems="center">
                        <Grid item xl={3} lg={4} sm={6} xs={12}>
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    freeSolo
                                    options={carrierOptions}
                                    loading={carrierLookupLoading}
                                    filterOptions={(options) => options}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        (typeof option === "string" ? option : option.name).toLowerCase() ===
                                        (typeof value === "string" ? value : value.name).toLowerCase()
                                    }
                                    inputValue={carrier}
                                    onInputChange={(_event, value, reason) => {
                                        if (reason === "input" || reason === "clear") {
                                            setCarrier(value);
                                        }
                                    }}
                                    onChange={(_event, value) => {
                                        if (typeof value === "string") {
                                            setCarrier(value);
                                            return;
                                        }
                                        if (value) {
                                            setCarrier(value.name);
                                            return;
                                        }
                                        setCarrier("");
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props} key={`${option.name}-${option.naicNumber ?? ""}`}>
                                            <Box sx={{ display: "flex", flexDirection: "column", py: 0.25 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 600, color: "#334155" }}>
                                                    {option.name}
                                                </Typography>
                                                {option.naicNumber ? (
                                                    <Typography variant="caption" sx={{ color: "#64748b" }}>
                                                        NAIC {option.naicNumber}
                                                    </Typography>
                                                ) : null}
                                            </Box>
                                        </li>
                                    )}
                                    sx={autocompleteFieldSx}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Carrier Name"
                                            size="small"
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    RunSearch();
                                                }
                                            }}
                                            InputLabelProps={{
                                                ...params.InputLabelProps,
                                                shrink:
                                                    carrier.length > 0 ||
                                                    (typeof params.inputProps.value === "string" &&
                                                        params.inputProps.value.length > 0)
                                                        ? true
                                                        : undefined,
                                            }}
                                            sx={autocompleteInputSx}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xl={3} lg={4} sm={6} xs={12}>
                            <TextField
                                name="naicNumber"
                                size="small"
                                value={naic}
                                label="NAIC Number"
                                onChange={(e) => setNaic(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        RunSearch();
                                    }
                                }}
                                fullWidth
                                variant="outlined"
                                sx={filterFieldSx}
                            />
                        </Grid>
                        <Grid item xs={12} sm="auto">
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    size="medium"
                                    onClick={RunSearch}
                                    startIcon={<Search />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        backgroundColor: '#2099d2',
                                        '&:hover': { backgroundColor: '#176990' },
                                    }}
                                >
                                    Search
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={ClearSearch}
                                    startIcon={<Clear />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderColor: '#e2e8f0',
                                        color: '#475569',
                                        '&:hover': { borderColor: '#2099d2', color: '#2099d2' },
                                    }}
                                >
                                    Clear
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {naicDatasetVersion?.isStale ? (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        The loaded NAIC Listing of Companies release is more than 7 months old.
                        Download the latest Detailed Listing from NAIC and refresh the reference data.
                    </Alert>
                ) : null}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                        border: '1px solid #e2e8f0',
                        backgroundColor: '#ffffff',
                        height: 'calc(100vh - 250px)',
                    }}
                >
                    <DataGridPro
                        getRowId={(r) => r.insuranceCompanyId}
                        rows={InsuranceComapnyCL}
                        columns={columns}
                        pagination
                        page={page}
                        onPageChange={(newPage) => setPage(newPage)}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => {
                            setPageSize(newPageSize);
                            setPage(0);
                        }}
                        rowsPerPageOptions={[25, 50, 100]}
                        components={{
                            Toolbar: EditToolbar,
                        }}
                        onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                        sortModel={sortModel}
                        experimentalFeatures={{ newEditingApi: true }}
                        sx={{
                            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                            border: 'none',
                            fontSize: '14px',
                            color: '#475569',
                            backgroundColor: '#ffffff',
                            '& .MuiDataGridPro-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: 1.35,
                                fontWeight: 600,
                                fontSize: '12px',
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase',
                                color: '#64748b',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f8fafc',
                                borderBottom: '2px solid #e2e8f0',
                                borderTop: '2px solid #e2e8f0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                '&:focus, &:focus-within': { outline: 'none' },
                            },
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease',
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#fafbfc',
                                },
                                '&:hover': {
                                    backgroundColor: '#f1f5f9 !important',
                                },
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f1f5f9',
                                fontSize: '14px',
                                color: '#334155',
                                overflow: 'visible',
                                whiteSpace: 'normal',
                                lineHeight: 'normal',
                                wordWrap: 'break-word',
                                textOverflow: 'clip',
                                padding: '8px 16px',
                                '&:focus': { outline: 'none' },
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                marginBottom: '0px !important',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-main': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-footerContainer': {
                                borderTop: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc',
                                minHeight: 56,
                            },
                            '& .MuiTablePagination-root': {
                                color: '#64748b',
                                fontSize: '13px',
                            },
                            '& .MuiTablePagination-select': {
                                fontSize: '13px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                            },
                            '& .MuiIconButton-root': {
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#475569',
                                },
                            },
                        }}
                    />
                </Box>
                <AddEditCarriermanagement setselectedLineOfBusiness={setselectedLineOfBusiness} handleClose={handleClose} Open={Open} InsuranceCompanyCL={Formdata} handleSubmit={handleSubmit} initValues={initialICData} selectedStates={selectedStates} States={States} setselectedStates={setselectedStates} setStates={setStates} handleCheckBoxChange={handleCheckBoxChange} selectedLineOfBusiness={selectedLineOfBusiness} LineOfBusiness={LineOfBusiness} handleLineOfBusinessCheckBoxChange={handleLineOfBusinessCheckBoxChange} selectAll={selectAll} handleStateEdit={handleStateEdit} ></AddEditCarriermanagement>
                <AddEditCarrierManageLineOfBussinessCheckBox currentState={currentState} handleClose={handleClose1} Open={Open1} InsuranceCompanyCL={Formdata} handleSubmit={handleSubmitLineofBusinessByState} initValues={initialICData} selectedStates={selectedStates} States={States} setselectedStates={setselectedStates} setStates={setStates} handleCheckBoxChange={handleCheckBoxChange} selectedLineOfBusiness={selectedLineOfBusiness} LineOfBusiness={LineOfBusiness} handleLineOfBusinessCheckBoxChange={handleLineOfBusinessCheckBoxChange} selectAll={selectAll} ></AddEditCarrierManageLineOfBussinessCheckBox>


            </div>
        </React.Fragment>
    )
}